import apiService from '../utils/apiInterceptor';

const packService = {
  pricing: async () => {
    return await apiService.get('/pricing');
  },
  getAllPacks: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add each param to query string if it exists
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.category_id) queryParams.append('category_id', params.category_id);
      if (params.status !== null && params.status !== undefined) 
        queryParams.append('status', params.status);
      
      const queryString = queryParams.toString();
      const url = `/admin/pack${queryString ? `?${queryString}` : ''}`;
      
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllPacks: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add each param to query string if it exists
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.category_id) queryParams.append('category_id', params.category_id);
      if (params.status !== null && params.status !== undefined) 
        queryParams.append('status', params.status);
      
      const queryString = queryParams.toString();
      const url = `/admin/pack${queryString ? `?${queryString}` : ''}`;
      
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },


  getPackById: async (id) => {
    try {
      const response = await apiService.get(`/admin/pack/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getPacksByCategory: async (categoryId) => {
    try {
      const response = await apiService.get(`/admin/pack?category_id=${categoryId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createPack: async (productData) => {
    try {
      const response = await apiService.post('/admin/pack', productData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePack: async (id, productData) => {
    try {
      const response = await apiService.post(`/admin/pack/${id}`, productData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-HTTP-Method-Override': 'PUT'
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deletePack: async (id) => {
    try {
      const response = await apiService.delete(`/admin/pack/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePackstatus: async (id, status) => {
    try {
      const response = await apiService.post('/change-pack-status', {
        product_id: id,
        status: status
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  exportPacks: async () => {
    try {
      const response = await apiService.get('/admin/pack/export', {
        responseType: 'blob'
      });
      
      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Packs.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      return true;
    } catch (error) {
      throw error;
    }
  },

  updateInventory: async (productId, quantity) => {
    try {
      const response = await apiService.post('/update-quantity', {
        product_id: productId,
        quantity: quantity
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // For pack management
  getPackItems: async (packId) => {
    try {
      const response = await apiService.get(`/admin/pack/${packId}/items`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  addPackItem: async (packId, itemData) => {
    try {
      const response = await apiService.post(`/admin/pack/${packId}/items`, itemData);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  removePackItem: async (packId, itemId) => {
    try {
      const response = await apiService.delete(`/admin/pack/${packId}/items/${itemId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default packService;